import { Button } from 'components/Button'
import Styles from '../Prompt.module.scss'

interface Props {
  loading: boolean
  onSuccess: () => void
  onCancel: () => void
  enabled: boolean
}

const PromptFooter = ({ loading, onSuccess, onCancel, enabled }: Props) => {
  return (
    <div className={Styles.footerWrapper}>
      <span>&nbsp;</span>
      <div className={Styles.footerActions}>
        <Button onPress={onCancel} isDisabled={loading} variant="secondary" size="sm" className={Styles.cancelButton}>
          Cancel
        </Button>
        <Button onPress={onSuccess} size="sm" isDisabled={loading || !enabled}>
          Embed Link
        </Button>
      </div>
    </div>
  )
}

export default PromptFooter
